import { useEffect, useState } from "react";

// Height of the on-screen keyboard covering the bottom of the layout viewport.
// The keyboard only shrinks the visual viewport, so `position: fixed` elements
// anchored to the bottom stay behind it unless lifted by this amount.
const useKeyboardInset = (): number => {
  const [inset, setInset] = useState(0);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;

    const handleViewportChange = () => {
      setInset(
        Math.max(
          0,
          Math.round(window.innerHeight - viewport.height - viewport.offsetTop),
        ),
      );
    };

    handleViewportChange();

    viewport.addEventListener("resize", handleViewportChange);
    viewport.addEventListener("scroll", handleViewportChange);
    return () => {
      viewport.removeEventListener("resize", handleViewportChange);
      viewport.removeEventListener("scroll", handleViewportChange);
    };
  }, []);

  return inset;
};

export default useKeyboardInset;
